export default {
	"6c62e638f52d4c776ec062ea32234985": "Sign up by scanning the code with Alipay",
	"33cc31ef12300116a075383071d575bf": "Go to Alipay to sign up",
	"b8a0a775103ed39c38f92a1f102888cd": "Cancel payment"
}
